import { useSelector } from "react-redux";
import { injectIntl } from "react-intl";
import { budgetFourDIc } from "../../utils/transformers";
import CustomChart from "../chartjs/chart";

const BudgetChart2 = ({ intl }) => {
  const { graficoBilancio2 } = useSelector(state => budgetFourDIc(state));
  const data = JSON.parse(JSON.stringify(graficoBilancio2.data));
  const options = JSON.parse(JSON.stringify(graficoBilancio2.options));
  const type = JSON.parse(JSON.stringify(graficoBilancio2.type));
  data.datasets.forEach(ds => {
    ds.fill = false;
    ds.pointRadius = 5;
    ds.pointHoverRadius = 8;
  });

  return <CustomChart type={type} title={intl.formatMessage({ id: "app.analyze.chart2_title" })} options={options} data={data}/>
}

export default injectIntl(BudgetChart2);